export default {
  apiUrl: {
    roleUrl: {
      getList: "/base/system/role/getList", //列表
      addRole: "/base/system/role/addRole", //添加
      editRole: "/base/system/role/editRole", //编辑
      removeRole: "/base/system/role/removeRole", //删除
      getDetail: "/base/system/role//getDetail", //查询某个
      getResource: "/base/system/user/getResource" //资源树
    },
    //字典类型管理
    dictionaryTypeUrl: {
      getDataDictTypeList: "/api/system/dataDictType/getDataDictTypeList", //列表
      saveDataDictType: "/api/system/dataDictType/saveDataDictType", //添加字典类型
      getDataDictTypeById: "/api/system/dataDictType/getDataDictTypeById", //查询单个
      updateDataDictTypeById: "/api/system/dataDictType/updateDataDictTypeById", //编辑
      deleteDataDictTypeByIds:
        "/api/system/dataDictType/deleteDataDictTypeByIds" //删除
    },
    personUrl: {
      getList: "/base/system/user/getList", //人员列表
      getRole: "/base/system/role/getRole", //角色下拉
      addUser: "/base/system/user/addUser", //新增人员
      editUser: "/base/system/user/editUser", //编辑人员
      removeUser: "/base/system/user/removeUser", //删除人员
      getMember: "/base/system/user/getMember"
    },
    messageUrl:{
      getMsgList:'/push/task/msgList',//获取消息列表
      removeMsg:'/push/task/delMsg',//删除消息
      copyMsg:'/push/task/cloneMsg',//复用消息
      getCopyData:'/push/task/selectMsg',//获取复用消息数据
      submitMsg:'/push/task/createPush'//发布信息
    }
  }
};
